import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import type {
  PostConversationalPreviewSettingsErrors,
  PostConversationalPreviewSettingsProps,
  PostConversationalPreviewSettingsResult,
} from "./types";

export const postConversationalPreviewSettings = reactQueryMutationAdapter(
  [],
  createMutationFetcherFunctionWithShadowError<PostConversationalPreviewSettingsErrors>()(
    (props: PostConversationalPreviewSettingsProps): Promise<PostConversationalPreviewSettingsResult> => {
      return fetch(`/${props.appGroupId}/conversational/preview_settings`, "POST", {
        session_id: props.sessionId,
        user_message: props.userMessage,
        user_id: props.userId,
        app_id: props.appId,
        subscription_group_id: props.subscriptionGroupId,
        include_drafts: props.includeDrafts,
        conversational_setting: props.conversationalSetting,
      });
    }
  )
);
